import {TimeTableTime} from './BusinessScheduleItemInterfaces'
import {Nullable} from '../../../../app/TypeHelpers'
import {HOURS_24, RESERVATION_TIME_UNIT_MINUTES} from '../../../../CodeMaster'

export const createHourArray = (start: TimeTableTime<HOURS_24>, end: TimeTableTime<HOURS_24>): number[] => {
    const startHour: number = Number(start.hour.value)
    let endHour: number = Number(end.hour.value)
    if (Number(end.minute.value) + 60 > 60) {
        endHour = endHour + 1
    }
    if (process.env.NODE_ENV === 'test') {
        return []
    }

    return HOURS_24.values()
        .map(hourEnum => Number(hourEnum.value))
        .filter(hour => (startHour <= hour && hour <= endHour))
}

export const formatTimeString = (time: TimeTableTime<HOURS_24>): string => {
    const hour: string = `${time.hour.value}時`
    const minute: string = time.minute !== RESERVATION_TIME_UNIT_MINUTES.VOL_0 ? `${time.minute.value}分` : ''
    return `${hour}${minute}`
}

export const compare = (left: Nullable<TimeTableTime<HOURS_24>>, right: Nullable<TimeTableTime<HOURS_24>>): number => {
    if (left === null || right === null) {
        return 0
    }
    return convertToMinutes(left) - convertToMinutes(right)
}

export const convertToMinutes = (time: TimeTableTime<HOURS_24>): number => {
    return Number(time.hour.value) * 60 + Number(time.minute.value)
}
